// src/components/layout/SideMenu.jsx
import React from 'react';
import { 
  X, User, Home, Calendar, History, MessageSquare, 
  ShoppingBag, Award, ToggleLeft, Camera 
} from 'lucide-react';
import MenuItem from '../common/MenuItem';
import ToolIcon from '../common/ToolIcon';

const SideMenu = ({ menuOpen, setMenuOpen, setActiveScreen }) => {
  if (!menuOpen) return null;

  const userName = sessionStorage.getItem('userName') || 'João Silva';
  
  return (
    <div className="side-menu absolute top-0 left-0 h-screen w-72 bg-white z-10 shadow-xl rounded-r-xl">
      <div className="bg-gradient-to-r from-[#068cb0] to-[#033f4f] p-6 flex flex-col">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-white text-lg font-semibold">Menu</h2>
          <X 
            className="text-white cursor-pointer bg-green-700 p-1 rounded-md" 
            onClick={() => setMenuOpen(false)}
            size={22}
          />
        </div>
        
        <div className="flex items-center">
          <div className="w-14 h-14 bg-white rounded-full flex items-center justify-center shadow-md mr-3">
            <User size={24} className="text-green-600" />
          </div>
          <div>
            <p className="font-medium text-white">{userName}</p>
            <div className="bg-green-700 text-green-100 text-xs px-2 py-1 rounded-full font-medium mt-1 inline-block">
              Plano Premium
            </div>
          </div>
        </div>
      </div>
      
      <div className="p-4 overflow-y-auto h-[calc(100vh-160px)] ">
        <MenuItem icon={<Home size={18} />} text="Início" onClick={() => {setActiveScreen('home'); setMenuOpen(false);}} />
        <MenuItem icon={<Calendar size={18} />} text="Agenda" onClick={() => {setActiveScreen('agenda'); setMenuOpen(false);}} />
        <MenuItem icon={<History size={18} />} text="Histórico" onClick={() => {setActiveScreen('history'); setMenuOpen(false);}} />
        <MenuItem icon={<MessageSquare size={18} />} text="Chat com Especialistas" onClick={() => {setActiveScreen('chat'); setMenuOpen(false);}} />
        <MenuItem icon={<ShoppingBag size={18} />} text="Loja" onClick={() => {setActiveScreen('shop'); setMenuOpen(false);}} />
        <MenuItem icon={<Award size={18} />} text="Clube Verde" onClick={() => {setActiveScreen('green-club'); setMenuOpen(false);}} />
        <MenuItem icon={<ToggleLeft size={18} />} text="Controle de Automação" onClick={() => {setActiveScreen('automation'); setMenuOpen(false);}} />
        <MenuItem icon={<Camera size={18} />} text="Câmeras ao Vivo" onClick={() => {setActiveScreen('cameras'); setMenuOpen(false);}} />
        <MenuItem icon={<ToolIcon size={18} />} text="Área Profissional" onClick={() => {setActiveScreen('pro'); setMenuOpen(false);}} />
        
        <div className="border-t border-gray-200 my-4"></div>
        <button
          className="w-full py-2 text-red-500 font-medium flex items-center justify-center rounded-md hover:bg-red-100"
          onClick={() => {setActiveScreen('login'); setMenuOpen(false);}}
        >
          Sair
        </button>
      </div>
    </div>
  );
};

export default SideMenu;